<template>
  <page-layout :title="boardData.categoryNm">
    <template v-slot:content>
      <v-container class="board-write-container">
        <div class="board-write-layout">
          <div class="board-write-title">
            <span class="text-h4">글쓰기</span>
          </div>
          <div class="board-write-content-layout">
            <div class="board-notice-level">
              <v-select
                v-model="writeData.noticeLevel"
                :items="noticeLevelList"
                item-text="text"
                item-value="value"
                placeholder="카테고리를 선택해주세요"
                outlined hide-details dense
                background-color="white"
              />
            </div>
            <div v-if="isAdmin">
              <v-row>
                <v-col cols="2">
                  <v-checkbox
                      label="팝업공지여부"
                      v-model="writeData.popupYn"
                      @change="changePopupYn"
                  />
                </v-col>
                <v-col v-if="writeData.popupYn" class="d-flex justify-center align-center" cols="4">
                  <single-date-input
                    :start-date="writeData.popupStDt"
                    @updateDate="updateStartDate"
                  />
                  <span style="margin: 0 5px">~</span>
                  <single-date-input
                    :start-date="writeData.popupEdDt"
                    @updateDate="updateEndDate"
                  />
                </v-col>
              </v-row>
            </div>
            <div class="board-write-title">
              <v-text-field
                  v-model="writeData.title"
                  placeholder="제목을 입력해주세요"
                  outlined hide-details
                  background-color="white"
              />
            </div>
            <div class="board-write-content">
              <v-textarea
                  v-model="writeData.content"
                  placeholder="내용을 입력해주세요"
                  outlined hide-details auto-grow
                  rows="4" row-height="100"
              />
            </div>
            <div class="file-input-layout">
              <v-file-input
                v-model="files"
                accept=".jpg, .jpeg, .png, .pdf, .zip, .xlsx, .ppt, .pptx, .docx, .hwp, .hwpx"
                small-chips show-size multiple clearable outlined
                prepend-icon="" prepend-inner-icon="mdi-paperclip" placeholder="파일을 첨부해주세요."
                @change="fileUpload"
              >
                <template v-slot:selection="{ text, index }">
                  <v-chip
                    small
                    text-color="white"
                    color="#295671"
                    close @click:close="removeFile(index)"
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </div>
          </div>
          <div class="buttons-layout">
            <v-btn class="button save" outlined @click="saveBoard">등록하기</v-btn>
            <v-btn class="button delete" outlined @click="previousPage">취소</v-btn>
          </div>
        </div>
      </v-container>
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import constant from "@/util/constant";
import {axiosInstance} from "@/util/AxiosModule";
import router from "@/router";
import {mapGetters} from "vuex";
import _ from "lodash";
import SingleDateInput from "@/common/components/input/SingleDateInput.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "BoardWrite",
  components: {SingleDateInput, PageLayout},
  mixins: [DateMixin],
  data() {
    return {
      boardData: {},
      writeData: {
        popupStDt: "",
        popupEdDt: "",
        popupYn: false
      },
      files: [],
      base64Files: []
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId",
      isAdmin: "isAdmin",
      memberRole: "memberRole"
    }),
    noticeLevelList() {
      if (this.memberRole === "MANAGER") {
        return constant.NOTICE_LEVEL_LIST.filter(item => item.value === 1);
      }
      return constant.NOTICE_LEVEL_LIST;
    }
  },
  mounted() {
    this.boardData = JSON.parse(sessionStorage.getItem("boardDetailList"));
  },
  methods: {
    setDefaultDate() {
      const {fromDate, toDate} = this.setDateDiff(14);
      this.writeData.popupStDt = fromDate;
      this.writeData.popupEdDt = toDate;
    },
    updateStartDate(value) {
      this.writeData.popupStDt = value;
    },
    updateEndDate(value) {
      this.writeData.popupEdDt = value;
    },
    changePopupYn(value) {
      if (value) {
        this.setDefaultDate();
      } else {
        this.writeData.popupStDt = "";
        this.writeData.popupEdDt = "";
      }
    },
    async fileUpload(files) {
      this.files = files;
      this.base64Files = [];

      for (const file of Array.from(files)) {
        try {
          const base64String = await this.getFileBase64(file);

          const removeFileTypeNm = file.name.replace(/\.[^/.]+$/, '');

          let fileType = file.type.split("/")[1];
          const excelType = "vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const wordType = "vnd.openxmlformats-officedocument.wordprocessingml.document";
          const pptType = "vnd.openxmlformats-officedocument.presentationml.presentation";
          if (fileType === excelType) {
            fileType = "xlsx";
          }
          if (fileType === wordType) {
            fileType = "docx";
          }
          if (fileType === pptType) {
            fileType = "pptx";
          }
          if (
              file.type === "" ||
              fileType === "haansofthwp"
          ) {
            fileType = "hwp";
          }
          if (fileType === "x-zip-compressed") {
            fileType = "zip";
          }

          this.base64Files.push({
            fileNm: removeFileTypeNm,
            fileType: fileType,
            fileStr: base64String
          });
        } catch (error) {
          await this.showAlert({message: `${error.response.data.message}`});
        }
      }
    },
    getFileBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    saveBoard() {
      if (
          this.writeData.noticeLevel === undefined ||
          _.isEmpty(this.writeData.title) ||
          _.isEmpty(this.writeData.content)
      ) {
        this.showAlert({message: "작성내용을 다시한번 확인해주세요"});
        return false;
      }

      this.showConfirm({
        message: "작성하신 게시물을 저장하시겠습니까?",
        successCallback: () => {
          this.save();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async save() {
      const boardInfo = {
        board: _.cloneDeep(this.writeData),
        files: this.base64Files
      };
      boardInfo.board["createId"] = this.memberId;
      boardInfo.board["categoryId"] = Number(this.boardData.categoryId);
      if (boardInfo.board.popupYn) {
        boardInfo.board["popupStDt"] = boardInfo.board.popupStDt.replaceAll("-", "");
        boardInfo.board["popupEdDt"] = boardInfo.board.popupEdDt.replaceAll("-", "");
      }
      boardInfo.board["popupYn"] = boardInfo.board.popupYn ? "Y" : "N";
      await axiosInstance.post("/private/board/board", boardInfo)
          .then(() => {
            this.showAlert({
              message: "작성한 게시물이 저장완료되었습니다.",
              successCallback: () => {
                router.push({name: "BoardTable", params: {categoryId: this.boardData.categoryId}});
              }
            })
          })
    },
    previousPage() {
      this.showConfirm({
        message: "이전 페이지로 이동 시 작성하던 데이터는 삭제됩니다. 이동하시겠습니까?",
        successCallback: () => {
          this.goBack();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Board/BoardWrite.scss";
</style>